import { USER_DETAIL } from "store/actions/type";
export default function userDetail(state = {}, action) {
    switch (action.type) {
        case USER_DETAIL:
            return action.payload;
        default:
            return state
    }
}